import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MaterialUiModule } from '../material-ui-module/material-ui.module';
import { ButtonModule } from './button/button.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { PipesModule } from '../pipes/pipes.module';
import { VideoComponent } from './video/video.component';
import { VideoCaptionsComponent } from './video/video-captions/video-captions.component';
import { VideoTranscriptComponent } from './video/video-transcript/video-transcript.component';
import { SliderComponent } from './slider/slider.component';
import { DialogModule } from './dialog/dialog.module';
import { BubbleMapComponent } from './maps/bubble-map/bubble-map.component';
import { PointMapComponent } from './maps/point-map/point-map.component';
import { CitySelectorComponent } from './city-selector/city-selector.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { NewsCardComponent } from './news-card/news-card.component';
import { MessageComponent } from './message/message.component';
import { SafePipe } from '../pipes/safe/safe.pipe';
import { SkeletonCardComponent } from './skeleton-card/skeleton-card.component';
import { SkeletonTableComponent } from './skeleton-table/skeleton-table.component';
import { DirectivesModule } from '@cpd-app/shared-module/directives/directives.module';
import { ViaPanelComponent } from './via-panel/via-panel.component';
import { ViaPanelContainerComponent } from './via-panel/via-panel-container.component';
import { BranchPickerComponent } from './branch-picker/branch-picker.component';
import { CredentialRecordComponent } from './credential-record/credential-record.component';
import { CredentialDrawerComponent } from './credential-drawer/credential-drawer.component';

@NgModule({
  imports: [
    RouterModule,
    ButtonModule,
    CommonModule,
    DialogModule,
    MaterialUiModule,
    PipesModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    DirectivesModule,
    VideoCaptionsComponent,
    VideoTranscriptComponent
  ],
  declarations: [
    ViaPanelComponent,
    ViaPanelContainerComponent,
    ViaPanelContainerComponent,
    BranchPickerComponent,
    CredentialRecordComponent,
    CredentialDrawerComponent,
    SliderComponent,
    SpinnerComponent,
    VideoComponent,
    BubbleMapComponent,
    PointMapComponent,
    CitySelectorComponent,
    BreadcrumbsComponent,
    NewsCardComponent,
    MessageComponent,
    SkeletonCardComponent,
    SkeletonTableComponent
  ],
  exports: [
    ViaPanelComponent,
    BranchPickerComponent,
    CredentialRecordComponent,
    CredentialDrawerComponent,
    ButtonModule,
    DialogModule,
    SliderComponent,
    SpinnerComponent,
    VideoComponent,
    BubbleMapComponent,
    PointMapComponent,
    CitySelectorComponent,
    BreadcrumbsComponent,
    NewsCardComponent,
    SkeletonCardComponent,
    SkeletonTableComponent
  ],
  providers: [SafePipe]
})
export class ComponentsModule {}
